import { Zap } from 'lucide-react'
import { Button, EmptyState } from '@shared/design-system/ui'
import { optIn as optInClass } from './recupera-ai.css'

export function RecuperaOptIn({
  onActivate,
  activating,
}: {
  onActivate: () => void
  activating: boolean
}) {
  return (
    <div className={optInClass} data-testid="recupera-ai-opt-in">
      <EmptyState
        icon={<Zap size={23} />}
        title="Ative a Recuperação Nativa"
        description="Recupere carrinhos abandonados automaticamente por ligação com IA, SMS, WhatsApp e e-mail."
        action={
          <Button
            variant="primary"
            onClick={onActivate}
            disabled={activating}
            data-testid="recupera-ai-opt-in-btn"
          >
            {activating ? 'Ativando...' : 'Ativar recuperação nativa'}
          </Button>
        }
      />
    </div>
  )
}
